export const List = {
  baseStyle: {
    item: {
      '&:not(:last-child)': {
        marginBottom: "0.5rem",
      },
    }
  },
};
